import { render, staticRenderFns } from "./Patient_count.vue?vue&type=template&id=5262a1e5&scoped=true"
import script from "./Patient_count.vue?vue&type=script&lang=js"
export * from "./Patient_count.vue?vue&type=script&lang=js"
import style0 from "./Patient_count.vue?vue&type=style&index=0&id=5262a1e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5262a1e5",
  null
  
)

export default component.exports